import type { PaymentStatusType } from '@/types/domain/photo/valueObjects/paymentStatus';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';
import { PAYMENT_STATUS_TYPE } from '@/types/domain/photo/valueObjects/paymentStatus';

export class PaymentStatus extends PrimitiveValueObject<PaymentStatusType> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: PaymentStatusType): PaymentStatus {
    return new PaymentStatus(value);
  }

  /** ラベル */
  static get label(): string {
    return '支払い状態';
  }

  /** キー */
  static get key(): string {
    return 'paymentStatus';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** リスト */
  static get list(): {
    /** ID */
    id: string,
    /** 名前 */
    name: string,
  }[] {
    const items = [];
    for (let i = 0; i < PAYMENT_STATUS_TYPE.length; i += 1) {
      items.push({
        id: PAYMENT_STATUS_TYPE[i],
        name: PAYMENT_STATUS_TYPE[i],
      });
    }
    return items;
  }
}
